import React, { Component } from 'react'
import {Switch, Route, Redirect} from 'react-router-dom';
import { app } from "../app"
import MyFrame from "../components/Frame"
import UserSign from "./sign/UserSign"
import '../css/sign.css'

function checkMenu (path) {
    let key = '1'
    switch (path) {
        case '/sign':
            key = '1'
            break
    }
    return key
}

class Sign extends Component {
    constructor (props) {
        super(props)
        this.state = {
            menu_key: checkMenu(props.location.pathname),
        }
    }

    componentDidMount () {
        this._isMounted = true
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        let isLogin = app.checkLogin()
        if (isLogin) {
            return (<Redirect to="/"/>)
        } else {
            let { menu_key } = this.state,
                menuList = [
                    {key: '1', text: '签到', link: '/sign'}
                ], nodeList = []
            return (
                <MyFrame className="sign" history={this.props.history} menuList={menuList} menuSelectKey={menu_key}>
                    <Switch>
                        {nodeList}
                        <Route  component={UserSign}/>
                    </Switch>
                </MyFrame>
            )
        }
    }
}

export default Sign



// WEBPACK FOOTER //
// ./src/routes/Sign.jsx